import { z } from 'zod';
import { isValidCpfOrCnpj } from '../utils/index.js';

export const customerInfoSchema = z.object({
  customerName: z
    .string()
    .min(3, 'Nome deve ter pelo menos 3 caracteres')
    .max(100, 'Nome deve ter no máximo 100 caracteres'),
  customerPhone: z
    .string({ error: 'Telefone é obrigatório' })
    .regex(/^\(\d{2}\) \d{5}-\d{4}$/, 'Telefone incompleto'),
  customerEmail: z
    .string({ error: 'Email é obrigatório' })
    .email('Email inválido'),
  customerCpf: z
    .string({ error: 'CPF/CNPJ é obrigatório' })
    .regex(
      /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/,
      'CPF/CNPJ inválido (ex: 000.000.000-00 ou 00.000.000/0000-00)'
    )
    .refine(isValidCpfOrCnpj, 'CPF/CNPJ inválido'),
});

export type CustomerInfoFormData = z.infer<typeof customerInfoSchema>;

export const vehicleInfoSchema = z.object({
  vehiclePlate: z
    .string()
    .regex(/^[A-Z]{3}\d[A-Z0-9]\d{2}$/, 'Placa inválida (formato Mercosul: ABC1D23)'),
  vehicleVin: z
    .string()
    .regex(/^[A-HJ-NPR-Z0-9]{17}$/, 'Chassi inválido (17 caracteres alfanuméricos, sem I, O, Q)')
    .optional(),
  vehicleMileage: z
    .number({ error: 'Quilometragem é obrigatória' })
    .int('Quilometragem deve ser um número inteiro')
    .min(0, 'Quilometragem não pode ser negativa')
    .max(999999, 'Quilometragem inválida'),
  modelId: z
    .string()
    .uuid('Selecione um modelo'),
  versionId: z
    .string()
    .uuid('Selecione uma versão'),
});

export type VehicleInfoFormData = z.infer<typeof vehicleInfoSchema>;

export const lgpdConsentSchema = z.object({
  lgpdConsent: z
    .boolean()
    .refine((val) => val === true, 'Você deve aceitar os termos de proteção de dados'),
});

export type LgpdConsentFormData = z.infer<typeof lgpdConsentSchema>;

export const bookingFormSchema = customerInfoSchema
  .merge(vehicleInfoSchema)
  .merge(lgpdConsentSchema);

export type BookingFormData = z.infer<typeof bookingFormSchema>;
